import * as React from 'react'
import styled from 'styled-components'

import media from '../../../../services/generateMediaQueries'
import formatDisplaySchedule from '../../../../services/schedule/formatDisplaySchedule'

import Section from '../../../../components/ui/Section/Section'
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import EventsCard from '../../../../components/home/EventsCard/EventsCard'

const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  overflow-x: hidden;

  & > section {
    margin-bottom: 0;
  }

  ${media.lessThan('medium')`
    background: var(--color-secondary);
    overflow-x: hidden;
  `}
`

class EventsSection extends React.Component {
  eventsSlider = React.createRef()

  eventsSliderNext = () => {
    this.eventsSlider.current.slickNext()
  }

  eventsSliderPrev = () => {
    this.eventsSlider.current.slickPrev()
  }

  render() {
    const { eventPreview = {} } = this.props

    const formattedSchedule = formatDisplaySchedule(eventPreview.schedule || '')

    return (
      <SectionWrapper>
        <Section
          sectionTitle="section.title"
          sectionText="section.description"
          sectionContentType="small"
          sliderNext={this.eventsSliderNext}
          sliderPrev={this.eventsSliderPrev}
          onClick={e => e.preventDefault()}
          lightOnSmall
        >
          <CardSlider
            dataSource={Array.from(Array(3))}
            ref={this.eventsSlider}
            renderItem={(item, index) => (
              <EventsCard
                key={index}
                id={index}
                bannerImageUrl={eventPreview.imageUrl || ''}
                logoImageUrl={eventPreview.logoUrl || ''}
                subtitle={formattedSchedule}
                title={eventPreview.title || ''}
                onClick={e => e.preventDefault()}
              />
            )}
          />
        </Section>
      </SectionWrapper>
    )
  }
}

EventsSection.defaultProps = {
  // TODO: specify default props
}

EventsSection.propTypes = {
  // TODO: specify prop types
}

export default EventsSection
